import { useInfiniteQuery } from "@tanstack/react-query";
import { GeneralResponse, IArea, Token } from "../../../types/api";

import { LongStaleTime, Methods } from "../../constants/CommonConstants";
import { IAreasRequests, IAreasResponse } from "../../../types/apis/general";
import Api from "../axios";
import { EndPoints } from "../endPoints";

export const fetchAreas = async ({
  payload,
  token,
}: {
  payload: IAreasRequests;
  token: Token;
}): Promise<GeneralResponse> => {
  const filteredPayload: Record<string, string | number | boolean> = {};

  if (payload.Start !== undefined && payload.Start !== null) {
    filteredPayload.Start = payload.Start;
  }
  if (payload.Count !== undefined && payload.Count !== null) {
    filteredPayload.Count = payload.Count;
  }
  if (payload.Name !== undefined && payload.Name !== null) {
    filteredPayload.Name = encodeURIComponent(payload.Name);
  }

  const queryString = Object.keys(filteredPayload)
    .map((key) => `${key}=${filteredPayload[key]}`)
    .join("&");
  return await Api<any, GeneralResponse<IAreasResponse[]>>({
    method: Methods.GET,
    endpoint: `${EndPoints.areas}?CityId=${payload.CityId}&${queryString}`,
    token,
  });
};

export const useInfiniteAreas = (
  payload: IAreasRequests | null,
  token: Token,
  enabled: boolean,
) => {
  const Count = payload?.Count ?? 10;

  return useInfiniteQuery<GeneralResponse<IArea[]>, Error>({
    queryKey: ["infinite-areas", { ...payload, Count }],
    queryFn: ({ pageParam = 0 }: any) =>
      fetchAreas({
        payload: {
          ...payload,
          Start: pageParam,
          Count,
          Name: payload?.Name,
          CityId: payload?.CityId ?? null,
        },
        token,
      }),
    enabled,
    initialPageParam: 0,
    staleTime: LongStaleTime,
    getNextPageParam: (lastPage, pages) => {
      if (lastPage.Data.length === 0) {
        return undefined;
      }
      return pages.length * Count;
    },
  });
};
